import {
    DOCTOR_SUCCESS,
    DOCTOR_FAIL,
    SET_MESSAGE,
    DOCTOR_PENDING,
    ADD_DOCTOR_SUCCESS,
    ADD_DOCTOR_FAIL,
    ADD_DOCTOR_PENDING,
    UPDATE_DOCTOR_SUCCESS,
    UPDATE_DOCTOR_FAIL,
    UPDATE_DOCTOR_PENDING,
    DOCTOR_PRACTICELOCATION_SUCCESS,
    DOCTOR_PRACTICELOCATION_FAIL,
    DOCTOR_PRACTICELOCATION_PENDING,
    DOCTOR_SUGGESTIONS_FAIL,
    DOCTOR_SUGGESTIONS_SUCCESS,
    DOCTOR_SUGGESTIONS_PENDING,
    DOWNLOAD_DOCTOR_PENDING, 
    DOWNLOAD_DOCTOR_SUCCESS, 
    DOWNLOAD_DOCTOR_FAIL

} from "../types";
import UserService from "../../services/user.service";
import { toast} from 'react-toastify'; 

export const getDoctors = (body) => async(dispatch) => {
   
    dispatch({
        type: DOCTOR_PENDING,
        payload: { doctors: "isLoading" },
    });
    return await UserService.getDoctors(body).then(
        (data) => {
            data.data.status ?
                dispatch({
                    type: DOCTOR_SUCCESS,
                    payload: { doctors: data.data },
                }) :
                dispatch({
                    type: DOCTOR_FAIL,
                });
            return Promise.resolve();
        },
        (error) => {
            console.log("error......", error);
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: DOCTOR_FAIL,
            });

            dispatch({
                type: SET_MESSAGE,
                payload: message,
            });

            return Promise.reject();
        }
    ).catch((error) => {
        console.log(error)
    });
};


export const getDoctorSuggestions = (doctorName) => async(dispatch) => {
    dispatch({
      type: DOCTOR_SUGGESTIONS_PENDING
    });
    
    return await UserService.getDoctorSuggestions(doctorName).then(
      (response) => {
        console.log(response.data, 'Doctor suggestions API response'); 
                dispatch({
          type: DOCTOR_SUGGESTIONS_SUCCESS,
          payload: { suggestions: response.data.result || [] },
        });
        return Promise.resolve();
      },
      (error) => {
        console.log("error fetching doctor suggestions:", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          
        dispatch({
          type: DOCTOR_SUGGESTIONS_FAIL,
        });
          
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
          
        return Promise.reject();
      }
    ).catch((error) => {
      console.log(error);
    });
  };
    export const addDoctors = (body) => async(dispatch) => {
        dispatch({
            type: ADD_DOCTOR_PENDING,
            payload: { addDoctors: "isLoading" },
        });
        return await UserService.addDoctor(body).then(
            (data) => {
                data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
                data.data.status ?
                    dispatch({
                        type: ADD_DOCTOR_SUCCESS,
                        payload: { addDoctors : data.data.status },
                    }) :
                    dispatch({
                        type: ADD_DOCTOR_FAIL,
                        payload: { addDoctors : data.data.status },
                    });
                return Promise.resolve();
            },
            (error) => {
                console.log("error......", error);
                const message =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
    
                dispatch({
                    type: ADD_DOCTOR_FAIL,
                });
    
                dispatch({
                    type: SET_MESSAGE,
                    payload: message,
                });
    
                return Promise.reject();
            }
        ).catch((error) => {
            console.log(error)
        }).finally(()=>{
            dispatch({
              type: ADD_DOCTOR_FAIL
            })
          });
    };
    
    //update doctor
    export const updateDoctors = (body) => async(dispatch) => {
        dispatch({
            type: UPDATE_DOCTOR_PENDING,
            payload: { updateDoctors: "isLoading" },
        });
        return await UserService.updateDoctor(body).then(
            (data) => {
                data.data.status ? toast.success(data.data.message, {autoClose: 2000 }): toast.error(data.data.message, {autoClose: 2000 });
                data.data.status ?
                    dispatch({
                        type: UPDATE_DOCTOR_SUCCESS,
                        payload: { updateDoctors : data.data.status },
                    }) :
                    dispatch({
                        type: UPDATE_DOCTOR_FAIL,
                        payload: { updateDoctors : data.data.status },
                    });
                return Promise.resolve();
            },
            (error) => {
                console.log("error......", error);
                const message =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
    
                dispatch({
                    type: UPDATE_DOCTOR_FAIL,
                });
    
                dispatch({
                    type: SET_MESSAGE,
                    payload: message,
                });
    
                return Promise.reject();
            }
        ).catch((error) => {
            console.log(error)
        }).finally(()=>{
            dispatch({
              type: UPDATE_DOCTOR_FAIL
            })
          });
          
    }
    export const getDoctorsByPracticeLocation = (body) => async(dispatch) => {
        console.log('getDoctorsByPracticeLocation action called'); 
    dispatch({
            type: DOCTOR_PRACTICELOCATION_PENDING,
            payload: { loadingDoctors: true },
        });
        return await UserService.getDoctorsByPracticeLocation(body).then(
            (data) => {
                
                console.log('API Respons>>>>>>>e:', data); 
                data.data.status ?
                    dispatch({
                        type: DOCTOR_PRACTICELOCATION_SUCCESS,
                        payload: { getDoctors: data.data.result, practiceLocationId: body.practiceLocationId },
                    }) :
                    dispatch({
                        type: DOCTOR_PRACTICELOCATION_FAIL,
                        payload: { getDoctors: [], practiceLocationId: body.practiceLocationId }
                    });
                return Promise.resolve();
            },
            (error) => {
                console.log("error......", error);
                const message =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
    
                dispatch({
                    type: DOCTOR_PRACTICELOCATION_FAIL,
                });
    
                dispatch({
                    type: SET_MESSAGE,
                    payload: message,
                });
    
                return Promise.reject();
            }
        ).catch((error) => {
            console.log(error)
        });
    };

   export const downloadDoctor = (body) => async (dispatch) => {
  dispatch({
    type: DOWNLOAD_DOCTOR_PENDING,
    payload: { downloadDoctor: "isLoading" },
  });
  try {
    const response = await UserService.downloadDoctor(body);
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
      : "Doctors.csv";
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    toast.success("Doctor file downloaded successfully!", { autoClose: 2000 });
    dispatch({
      type: DOWNLOAD_DOCTOR_SUCCESS,
      payload: { downloadDoctor: true },
    });
  } catch (error) {
    console.error("Error downloading doctor file:", error);
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error("Failed to download the doctor file.", { autoClose: 2000 });
    dispatch({
      type: DOWNLOAD_DOCTOR_FAIL,
      payload: { downloadDoctor: false },
    });
  }
};
// Get assigned doctors for a specific team
export const getAssignedDoctors = (teamId) => async (dispatch) => {
    try {
        const response = await UserService.getDoctors({
            pageNumber: -1,
            pageSize: 0,
            textSearch: '',
            cityId: 0,
            practiceLocationId: 0,
            rankId: 0,
            specializationId: 0,
            designationId: 0,
            teamId: teamId
        });

        const assignedDoctors = response?.data?.result || [];
        const preselectedIds = assignedDoctors.map(d => d.id);

        return Promise.resolve({ preselectedIds, assignedDoctors });

    } catch (error) {
        console.error('Error fetching assigned doctors:', error);
        return Promise.reject(error);
    }
};

// Get all available doctors for selection
export const getAllDoctors = (searchParams = {}) => async (dispatch) => {
    dispatch({
        type: DOCTOR_PENDING,
        payload: { doctors: "isLoading" }
    });

    try {
        const response = await UserService.getDoctors({
            pageNumber: searchParams.pageNumber || 1,
            pageSize: searchParams.pageSize || 10,
            textSearch: searchParams.textSearch || '',
            cityId: searchParams.cityId || 0,
            practiceLocationId: searchParams.practiceLocationId || 0,
            rankId: searchParams.rankId || 0,
            specializationId: searchParams.specializationId || 0,
            designationId: searchParams.designationId || 0,
            teamId: 0  // Always 0 to get all doctors
        });

        if (response.data.status) {
            dispatch({
                type: DOCTOR_SUCCESS,
                payload: { doctors: response.data }
            });
            return response.data;
        } else {
            dispatch({ type: DOCTOR_FAIL });
            return null;
        }

    } catch (error) {
        console.error('Error fetching all doctors:', error);
        dispatch({ type: DOCTOR_FAIL });
        return null;
    }
};

// Legacy function - kept for backward compatibility but simplified
export const getDoctorsForTeam = (teamId) => async (dispatch) => {
    // This now just calls getAssignedDoctors for backward compatibility
    return dispatch(getAssignedDoctors(teamId));
};

